<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="mb-3">
                <b-button class="mr-2" variant="dark"><strong>Rp. {{ $helper.formatThousandSeparator(ukuran.harga) }}</strong></b-button>
                <b-button class="mr-2" variant="primary" @click="openEditUkuranModal">Edit Ukuran</b-button>
                <b-button variant="primary" @click="$bvModal.show('modal-input')">Tambah Warna Baru</b-button>
            </div>
            <b-table bordered hover show-empty
                :items="items"
                :fields="fields"
                responsive
            >
                <template v-slot:empty>
                    Tidak ada warna.
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Edit" @click="openEditModal(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                </template>
            </b-table>
        </div>
        <b-modal id="modal-input" title="Tambah Warna Baru"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.inputName.focus()"
        >
            <b-form-group label="Nama">
                <b-form-input ref="inputName" v-model="input.name" maxlength="25" />
            </b-form-group>
            <b-form-group label="SKU">
                <b-form-input v-model="input.sku" maxlength="25" />
            </b-form-group>
            <b-form-group label="Stok">
                <b-form-input type="number" v-model="input.stok" maxlength="10" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeInput">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-edit-ukuran" title="Edit Ukuran"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.editUkuranName.focus()"
        >
            <b-form-group label="Nama">
                <b-form-input ref="editUkuranName" v-model="editUkuran.name" maxlength="10" />
            </b-form-group>
            <b-form-group label="Harga">
                <b-form-input v-model="editUkuran.harga" maxlength="20" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeEditUkuran">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-edit" title="Edit Warna"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.editName.focus()"
        >
             <b-form-group label="Nama">
                <b-form-input ref="editName" v-model="edit.name" maxlength="25" />
            </b-form-group>
            <b-form-group label="SKU">
                <b-form-input v-model="edit.sku" maxlength="25" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeEditWarna">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'ukuran',
    props: {
        id: { type: Number, required: true }
    },
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            show: 10,

            ukuran: {},

            input: {
                name: "",
                sku: "",
                stok: 0
            },

            editUkuran: {
                name: "",
                harga: ""
            },

            edit: {
                name: "",
                sku: ""
            },

            fields: [
                { key: "name", label: "Nama Warna" },
                { key: "sku", label: "SKU" },
                { key: "stok", label: "Stok" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: null

        }
    },

    methods: {

        init() {

            this.initStatus = 0

            let getUkuranDetail = this.$axios.get("ukuran/" + this.id).then(res => {
                this.ukuran = res.data
            })

            let getWarna = this.$axios.get("warna/?ukuranId=" + this.id).then(res => {
                this.items = res.data
            })

            Promise.all([getUkuranDetail, getWarna]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        executeInput() {

            if(this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.sku)) {
                return this.$helper.toastError(this, "SKU tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.stok) || this.input.stok < 0) {
                return this.$helper.toastError(this, "Stok tidak boleh kosong atau negatif!")
            }

            let payload = new FormData()
            payload.append("name", this.input.name)
            payload.append("sku", this.input.sku)
            payload.append("stok", this.input.stok)
            payload.append("ukuranId", this.id)

            this.isSubmitting = true
            this.$axios.post("warna/new", payload).then(res => {

                this.items.push(res.data)

                this.$bvModal.hide("modal-input")
                this.$helper.toastSuccess(this, "Warna baru berhasil ditambahkan!")

                this.input.name = ""
                this.input.sku = ""
                this.input.stok = 0

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeEditWarna() {

            if(this.$helper.isBlank(this.edit.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.edit.sku)) {
                return this.$helper.toastError(this, "SKU tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("id", this.activeItem.id)
            payload.append("name", this.edit.name)
            payload.append("sku", this.edit.sku)

            this.isSubmitting = true
            this.$axios.post("warna/edit", payload).then(res => {

                this.$bvModal.hide("modal-edit")
                this.$helper.toastSuccess(this, "Warna berhasil diubah!")

                this.activeItem.name = res.data.name
                this.activeItem.sku = res.data.sku

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeEditUkuran() {

            if(this.$helper.isBlank(this.editUkuran.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.editUkuran.harga)) {
                return this.$helper.toastError(this, "Harga tidak boleh kosong!")
            }

            let harga = this.editUkuran.harga.replace(/\./g, "")

            let payload = new FormData()
            payload.append("id", this.id)
            payload.append("name", this.editUkuran.name)
            payload.append("harga", harga)
            payload.append("modelId", this.$route.params.id)

            this.isSubmitting = true
            this.$axios.post("ukuran/", payload).then(res => {

                this.ukuran.harga = res.data.harga
                this.$bvModal.hide("modal-edit-ukuran")
                this.$helper.toastSuccess(this, "Ukuran berhasil diubah!")

                this.$emit("on-edit-ukuran", res.data)

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        openEditUkuranModal() {

            this.editUkuran.name = this.ukuran.name
            this.editUkuran.harga = "" + this.ukuran.harga
            this.$bvModal.show('modal-edit-ukuran')

        },

        openEditModal(item) {

            this.activeItem = item
            this.edit.name = item.name
            this.edit.sku = item.sku
            this.$bvModal.show('modal-edit')

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

    },

    watch: {

        "editUkuran.harga": function(newValue) {
            const result = newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.$nextTick(() => this.editUkuran.harga = result)
        }

    },

    created(){
        this.init()
    }

}
</script>
